// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const PayrollClient = registerClientReference(
    function() { throw new Error("Attempted to call PayrollClient() from the server but PayrollClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(seller)/seller/payroll/payroll-client.tsx <module evaluation>",
    "PayrollClient",
);
